import React, { useState, useEffect } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useSubheader } from "../../../../_metronic/layout";
import {
  Card,
  CardBody,
  DateRangPickerField,
} from "../../../../_metronic/_partials/controls";
import moment from "moment";
import { Formik, Field } from "formik";
import {
  NotificationContainer,
  NotificationManager,
} from "react-notifications";
import { Col, Row, Button, Accordion } from "react-bootstrap";
import * as actions from "./_redux/Action";
import * as columnFormatters from "../../../components/column-formatters";
import { columns_contest_users } from "./columns";
import * as UIHelpers from "../../../components/UIHelpers";
import ColumnsFilter from "../../../components/ColumnsFilter";
import DataTable from "../../../components/DataTable";
// import SildepanelFilter from "./SidepanelFilter";
// import './ContestList.css';
import { useParams, useHistory } from "react-router-dom";
import helperFunc from "../../../../_metronic/_helpers/helperFunc";

import DropdownReactSelect from "../../../components/DropdownReactSelect";
import "../../../../_metronic/_assets/sass/customstyle.react.scss";
import "./company.css";

export const initialFilter = {
  sort: "desc", // asc||desc
  sortBy: "createdAt",
  skip: UIHelpers.skip,
  limit: UIHelpers.limit,
  page: UIHelpers.page,
  company: "GJ",
  country: "",
  dateRange: null, //{from: moment().toDate(), to: moment().toDate()}
  fromDate: null,
  toDate: null,
  q: "",
  filter: {
    game: "",
    gameType: "",
  },
  search: {},
};

export default function Companydetailpage(props) {
  const suhbeader = useSubheader();
  suhbeader.setTitle("Company Details");

  const dispatch = useDispatch();

  const { currentState, gameState } = useSelector(
    (state) => ({
      currentState: state.newAdscompanylistSlice,
      gameState: state.gameList,
    }),
    shallowEqual
  );
  // const { loginUserCompany } = gameState;
  const {
    entities,
    totalCount,
    listLoading,
    exportData,
    gameList,
    gameTypeList,
    company,
    coinStoresForEdit,
    countryDropdownList,
  } = currentState;

  const [filter, setFilter] = useState(initialFilter);
  const [dateRange, setDateRange] = useState({
    from: moment(new Date().setHours(0, 0, 0, 0)),
    to: moment(new Date().setHours(23, 59, 59, 999)),
  });
  const [isShowSectionDetails, setIsShowSectionDetails] = useState(false);
  const [rows, setRows] = useState([]);
  const [allColumns, setAllColumns] = useState(columns_contest_users);
  const [cols, setCols] = useState(columns_contest_users);
  const [page_no, setPageNo] = useState(1);
  const [countryDropdownFilterData, setCountryDropdownFilterData] = useState(
    []
  );
  const [
    countrySelectedDropdownFilterData,
    setCountryListDropdownFilterData,
  ] = useState();

  const [searchApply, setSearchApply] = useState(false);
  const [showColumnModal, setShowColumnModal] = useState(false);
  const [isShowSidepanel, setIsShowSidepanel] = useState(false);
  const { id } = useParams();
  const [getId, setID] = useState();
  const [responseData, setResponseData] = useState(null);
  const [
    gameSelectedDropdownFilterData,
    setGameSelectedDropdownFilterData,
  ] = useState(null);
  const [gameListDropdownFilterData, setGameListDropdownFilterData] = useState(
    []
  );

  const [companyDropdownFilterData, setCompanyDropdownFilterData] = useState(
    []
  );

  const [
    companySelectedDropdownFilterData,
    setCompanySelectedDropdownFilterData,
  ] = useState(null);

  const [
    gameTypeSelectedDropdownFilterData,
    setGameTypeSelectedDropdownFilterData,
  ] = useState(null);
  const [
    gameTypeListDropdownFilterData,
    setGameTypeListDropdownFilterData,
  ] = useState([]);

  const history = useHistory();
  useEffect(() => {
    dispatch(actions.fetchCountriesDropdownList());
  }, [dispatch]);

  useEffect(() => {
    const id = window.location.href.split("/")[
      window.location.href.split("/").length - 1
    ];
    dispatch(actions.fetchSingle(id))
      .then((coinStoresForEdit) => {
        if (
          coinStoresForEdit &&
          coinStoresForEdit.data &&
          coinStoresForEdit.data.length > 0
        ) {
          setResponseData(coinStoresForEdit.data[0]?.param);
          console.log("fjdgdfmgfgdfdffgfg", coinStoresForEdit.data[0]?.param); // Store the response data in the component state
        } else {
        }
      })
      .catch((error) => {
        // Handle the error if needed
        console.error(error);
      });
  }, [id, dispatch]);

  // useEffect(() => {
  //   if (id) {
  //     dispatch(actions.fetchSingle(id))
  //       .then((coinStoresForEdit) => {
  //         console.log("fjdgdfmgfgfgfg", coinStoresForEdit);
  //         setID(coinStoresForEdit?.item?._id);
  //       })
  //       .catch((error) => {
  //         console.error(error);
  //       });
  //   }
  // }, [id, dispatch]);
  useEffect(() => {
    if (countryDropdownList && countryDropdownList.data) {
      let temp = [];
      countryDropdownList.data.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      // console.log("temp:", temp);
      setCountryDropdownFilterData(temp);
    }
  }, [countryDropdownList]);
  const newItem = () => {
    const companyId = coinStoresForEdit?.data[0]?.param?._id;
    console.log("++++++", companyId);
    props.history.push(`/DownloadAdscompanylist/view/${companyId}`);
  };

  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userData?.company || [];
    let temp = [...columns_contest_users];
    setCols(temp);
    dispatch(actions.fetchCompanyList());
  }, []);

  useEffect(() => {
    let tempb = [];
    const userdata = JSON.parse(localStorage.getItem("userData"));
    const userCompany = userdata?.company || [];

    for (let i = 0; i < company.length; i++) {
      if (!helperFunc.isAdmin()) {
        if (userCompany.includes(company[i]._id)) {
          let obj = {};
          obj.label = company[i].name;
          obj.value = company[i]._id;
          tempb.push(obj);
        }
      } else {
        let obj = {};
        obj.label = company[i].name;
        obj.value = company[i]._id;
        tempb.push(obj);
      }
    }

    setCompanyDropdownFilterData(tempb);
  }, [company]);

  useEffect(() => {
    if (!helperFunc.isAdmin()) {
      const userdata = JSON.parse(localStorage.getItem("userData"));
      const userCompany = userdata?.company || [];
      var tampFilter = { search: { isGameList: true } };
      tampFilter.search.company = userCompany;

      // allColumns.splice(2, 1);
      setAllColumns([...allColumns]);

      setFilter(tampFilter);
      dispatch(actions.fetchGameList(tampFilter));
    } else {
      var tampFilter = { search: {} };
      tampFilter.search.company = null;
      setFilter(tampFilter);
      dispatch(actions.fetchGameList(tampFilter));
    }
  }, []);

  const viewItem = (row_value) => {
    if (helperFunc.isButtonAccess("downloadAds.adsCompanyList.get")) {
      // Company detail page redirect
      const IDs = localStorage.getItem("URLID");
      localStorage.setItem("AURLID", row_value?.AdsID);

      props.history.push(`/DownloadAdscompanylist/Adslogs/` + IDs);
    } else {
      NotificationManager.error("Access denied.", "Error");
    }
  };
  // const editItem = (id) => {
  //   props.history.push(`/DownloadAdscompanylist/edit-adds/${id}`);
  // };

  const editItem = (row_value) => {
    if (helperFunc.isButtonAccess("downloadAds.adsCompanyList.update")) {
      history.push("/DownloadAdscompanylist/edit-adds/" + row_value?.AdsID);
     // console.log("deshrtuuuuuuuu", row_value?.AdsID);
    }else{
      return NotificationManager.error("Access denied.", "Error");
    }
  };
  const reloadLocation = () => {
    window.location.reload();
  };

  useEffect(() => {
    if (gameList.length > 0) {
      let temp = [];
      gameList.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      setGameListDropdownFilterData(temp);
    }
  }, [gameList]);

  useEffect(() => {
    if (gameSelectedDropdownFilterData !== null) {
      var tampFilter = { ...filter };
      tampFilter.search.gameId = gameSelectedDropdownFilterData.value;
      setFilter(tampFilter);

      dispatch(actions.fetchGameTypeList(tampFilter));
    }
    setGameTypeSelectedDropdownFilterData(null);
    setGameTypeListDropdownFilterData([]);
  }, [gameSelectedDropdownFilterData]);

  useEffect(() => {
    if (gameTypeList.length > 0) {
      let temp = [];
      gameTypeList.forEach((element, i) => {
        temp.push({
          _id: i + 1,
          label: element.name,
          value: element._id,
        });
      });
      setGameTypeListDropdownFilterData(temp);
    }
  }, [gameTypeList]);

  useEffect(() => {
    console.log("entities: ", entities);
    if (entities && entities.length > 0) {
      setRows(entities);
    } else {
      setRows([]);
    }
  }, [entities]);

  const { companyId } = useParams();

  // ... (rest of your component code)
  const handleFilter = (values) => {
    applyFilter(values, companyId);
  };

  useEffect(() => {
    let tampFilter = { ...filter };
    let temp1 = [];
    let selectedFields = {};

    const temp_columns = columns_contest_users.map((value, i) => ({
      ...value,
      id: i,
    }));

    columns_contest_users.forEach((value) => {
      if (value?.show === true) {
        selectedFields[value?.dataField] = 1;
      }
    });

    setCols(temp_columns);
    tampFilter.fields = selectedFields;
    setFilter(tampFilter);

    temp_columns.forEach((item) => {
      if (item?.show === true) {
        temp1.push(item);
      }
    });

    temp1.push({
      dataField: "action",
      text: "Actions",
      sort: false,
      show: true,
      format: {
        type: "action",
        style: {
          width: "150px",
        },
        formatfunction: {
          viewItem: viewItem,
          editItem: editItem,
          // deleteItem: deleteItem,
        },
      },
    });

    setAllColumns(temp1);
  }, [columns_contest_users]);

  useEffect(() => {
    console.log("exportData: ", exportData);
    if (
      exportData &&
      exportData?.success &&
      exportData?.item &&
      exportData?.item?.fileName
    ) {
      window.open(
        `${UIHelpers.exportUrl}${exportData?.item?.fileName}`,
        "_blank"
      );
    }
  }, [exportData]);

  const applyFilter = (values, companyId) => {
    var check_type = true;
    var tampFilter = { ...filter };
    console.log("val::11::1", values);
    if (values?.dateRang) {
      tampFilter.dateRange = values.dateRang;
      setDateRange(values.dateRang);
      // Reset skip and page when date range is changed
      tampFilter.skip = 0;
      tampFilter.page = 1;
    }

    if (
      values?.dateRang &&
      values?.dateRang !== undefined &&
      values?.dateRang !== null
    ) {
      tampFilter.search.startAt = values.dateRang.from;
      tampFilter.search.endAt = values.dateRang.to;
      setDateRange(values.dateRang);
    } else {
      tampFilter.fromDate = null;
      tampFilter.toDate = null;
    }

    if (!helperFunc.isAdmin()) {
      if (!helperFunc.isButtonAccess("advertisers.advertisers.list")) {
        tampFilter.search.user = helperFunc.getUserData().id;
      }
    }
    // countriess multiple
    if (countrySelectedDropdownFilterData) {
      if (
        countrySelectedDropdownFilterData.some(
          (option) => option.value === "all"
        )
      ) {
        // Handle the "All Countries" selection
        tampFilter.search.country = companyDropdownFilterData.map(
          (option) => option.value
        );
      } else {
        tampFilter.search.country = countrySelectedDropdownFilterData.map(
          (option) => option.value
        );
      }
    } else {
      tampFilter.search.country = null;
    }

    // countriess multiple
    tampFilter.companyId = coinStoresForEdit?.item?._id;
    console.log("company idddddd", company[0]?._id);
    // coinStoresForEdit?.data[0]?.param?._id

    console.log("tampFilter::2", tampFilter, listLoading);

    setFilter(tampFilter);

    if (!listLoading && check_type) {
      setSearchApply(true);
      dispatch(actions.fetchAdsListList(tampFilter, coinStoresForEdit));
    }
  };

  // call then pass company id from url also

  const DataTablePaginationAPICall = (values, companyId, country) => {
    setSearchApply(true);
    var check_type = true;
    var tampFilter = { ...filter };
    console.log("val::11::1", values);

    // if (values?.skip) {
    tampFilter.skip = values.skip;
    tampFilter.page = values.page;
    // }
    if (values?.limit) {
      tampFilter.limit = values.limit;
    }
    if (!helperFunc.isAdmin()) {
      if (!helperFunc.isButtonAccess("downloadAds.adsCompanyList.list")) {
        tampFilter.search.user = helperFunc.getUserData().id;
      }
    }
    if (
      values?.dateRang &&
      values?.dateRang !== undefined &&
      values?.dateRang !== null
    ) {
      tampFilter.search.startAt = values.dateRang.from;
      tampFilter.search.endAt = values.dateRang.to;
      setDateRange(values.dateRang);
    } else {
      tampFilter.fromDate = null;
      tampFilter.toDate = null;
    }

    if (!helperFunc.isAdmin()) {
      if (!helperFunc.isButtonAccess("downloadAds.adsCompanyList.list")) {
        tampFilter.search.user = helperFunc.getUserData().id;
      }
    }

    if (
      countrySelectedDropdownFilterData &&
      countrySelectedDropdownFilterData.value !== undefined &&
      countrySelectedDropdownFilterData.value !== null
    ) {
      if (countrySelectedDropdownFilterData.value === "all") {
        // Handle the "All Countries" selection
        tampFilter.search.country = countryDropdownFilterData.map(
          (option) => option.value
        );
      } else {
        tampFilter.search.country = [
          String(countrySelectedDropdownFilterData.value),
        ];
      }
    } else {
      tampFilter.search.country = null;
    }
    tampFilter.companyId = coinStoresForEdit?.item?._id;
    // tampFilter.companyId = coinStoresForEdit?.item?._id;

    tampFilter.companyId = companyId; // Use the passed companyId instead of coinStoresForEdit
    tampFilter.search.startAt = values.dateRang ? values.dateRang.from : null;
    tampFilter.search.endAt = values.dateRang ? values.dateRang.to : null;

    tampFilter.search.company = country;
    console.log("company idddddd", country);
    // coinStoresForEdit?.data[0]?.param?._id
    setFilter(tampFilter);
    // setCount(count + 1);

    // console.log('tampFilter::', tampFilter, listLoading)
    if (!listLoading && check_type) {
      setSearchApply(true);
      dispatch(actions.fetchAdsListList(tampFilter, coinStoresForEdit));
    }
  };

  const exportButtonCSVAPICall = () => {
    console.log("exportButtonCSVAPICall");
    var tampFilter = { ...filter };
    // dispatch(actions.fetchUsersLedgerReportExport(tampFilter));
  };

  const updatedCols = (val) => {
    let temp1 = [...val];
    temp1.splice(1, 0, {
      dataField: "action",
      text: "Actions",
      sort: false,
      show: true,
      format: {
        type: "action",
        style: {
          width: "150px",
        },
        formatfunction: {
          viewItem: viewItem,
          //   editItem: editItem,
          //   deleteItem: deleteItem,
        },
      },
    });
    //console.log("item::12", temp1)
    setAllColumns(temp1);
  };

  const updatedFields = (allTempFields) => {
    let temp = [];
    let selectedFields = {};
    allTempFields.map((item, index) => {
      temp.push(item.dataField);
      selectedFields[item?.dataField] = 1;
    });

    var tampFilter = { ...filter };
    tampFilter.fields = selectedFields;
    setFilter(tampFilter);
    if (!listLoading) {
      dispatch(actions.fetchAdsListList(tampFilter));
    }
  };

  const addItem = () => {
    if (helperFunc.isButtonAccess("downloadAds.adsCompanyList.list")) {
      history.push("/contests/create");
      // props.history.push(`/users/staff-user/edit/${id}`);
    } else {
      NotificationManager.error("Access denied.", "Error");
    }
  };

  const createBasicDetails = () => {
    return (
      <Col lg={24} md={24} sm={24} xs={24}>
        <div>
          <Accordion>
            <div className="card card-custom gutter-b card_border">
              <div
                className="card-header ribbon ribbon-top ribbon-ver"
                style={{
                  backgroundColor: "var(--color_black)",
                  borderRadius: isShowSectionDetails ? "16px 16px 0 0" : "16px",
                  transition: "border-radius 1s",
                }}
              >
                {/* Title */}
                <div className="card-title text-white w-100 d-flex flex-column">
                  <div className="d-flex w-100">
                    <div className="d-flex align-items-center mr-14">
                      <span className="mr-6">
                        <i
                          className="fa fa-gamepad text-muted"
                          style={{ fontSize: "25px" }}
                        ></i>
                      </span>
                      <div className="d-flex flex-column flex-lg-fill text-white">
                        <div
                          className="text-white font-weight-bolder"
                          style={{ fontSize: "20px" }}
                        >
                          {coinStoresForEdit?.data[0]?.param?.companyName ||
                            null}
                        </div>
                        <span className="text-white-75 font-weight-bolder font-size-sm">
                          Company Name
                        </span>
                      </div>
                    </div>

                    <div className="d-flex align-items-center ml-auto">
                      <Accordion.Toggle as={Button} variant="link" eventKey="1">
                        <i
                          className={`${
                            isShowSectionDetails
                              ? "fas fa-chevron-circle-up"
                              : "fas fa-chevron-circle-down"
                          } icon-2x text-light ml-3`}
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setIsShowSectionDetails(!isShowSectionDetails);
                          }}
                        ></i>
                      </Accordion.Toggle>
                    </div>
                  </div>
                </div>
              </div>

              <Accordion.Collapse eventKey="1">
                <div className="card-body p-0">
                  <div
                    className="d-flex flex-column"
                    style={{ padding: "20px 20px 0 20px" }}
                  >
                    <div className="d-flex mb-9">
                      {/* Details */}
                      <div className="flex-grow-1">
                        <div className="d-flex flex-wrap justify-content-between">
                          {/* Detail Box */}
                          <div className="d-flex flex-column flex-grow-1 pr-8">
                            {/* First Row */}
                            <div className="d-flex flex-wrap">
                              <div
                                className="rounded min-w-125px py-3 px-4 mr-3"
                                style={{
                                  border:
                                    "1px dashed var(--color_color_input_text_border)",
                                }}
                              >
                                <div className="row m-0 p-0">
                                  {/* <img src={`${UIHelpers.imageUrl}${contestData?.currency?.img?.default}`} style={{ width: '35px', height: '35px', }} /> */}
                                  <i className="flaticon-users-1 display-4 text-muted font-weight-bold"></i>
                                  <div className="col">
                                    <div className="fs-4 fw-bolder">
                                      {coinStoresForEdit?.data[0]?.param?._id ||
                                        null}
                                    </div>
                                    <div
                                      className="font-weight-bold fs-6 text-gray-400"
                                      style={{
                                        color: "var(--color_border_color)",
                                      }}
                                    >
                                      Company ID
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div
                                className="rounded min-w-125px py-3 px-4 mr-3"
                                style={{
                                  border:
                                    "1px dashed var(--color_color_input_text_border)",
                                }}
                              >
                                <div className="row m-0 p-0">
                                  {/* <img src={`${UIHelpers.imageUrl}${contestData?.currency?.img?.default}`} style={{ width: '35px', height: '35px', }} /> */}
                                  <i className="flaticon-users-1 display-4 text-muted font-weight-bold"></i>
                                  <div className="col">
                                    <div className="fs-4 fw-bolder">
                                      {coinStoresForEdit?.data[0]?.param
                                        ?.contactPerson || null}
                                    </div>
                                    <div
                                      className="font-weight-bold fs-6 text-gray-400"
                                      style={{
                                        color: "var(--color_border_color)",
                                      }}
                                    >
                                      Contact Person
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="rounded min-w-125px py-3 px-4 mr-3"
                                style={{
                                  border:
                                    "1px dashed var(--color_color_input_text_border)",
                                }}
                              >
                                <div className="row m-0 p-0">
                                  {/* <img src={`${UIHelpers.imageUrl}${contestData?.currency?.img?.default}`} style={{ width: '35px', height: '35px', }} /> */}
                                  <i className="flaticon-users-1 display-4 text-muted font-weight-bold"></i>
                                  <div className="col">
                                    <div className="fs-4 fw-bolder">
                                      {coinStoresForEdit?.data[0]?.param
                                        ?.totalAds || 0}
                                    </div>
                                    <div
                                      className="font-weight-bold fs-6 text-gray-400"
                                      style={{
                                        color: "var(--color_border_color)",
                                      }}
                                    >
                                      Total Ads
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div
                                className="rounded min-w-125px py-3 px-4 mr-3"
                                style={{
                                  border:
                                    "1px dashed var(--color_color_input_text_border)",
                                }}
                              >
                                <div className="row m-0 p-0">
                                  {/* <img src={`${UIHelpers.imageUrl}${contestData?.currency?.img?.default}`} style={{ width: '35px', height: '35px', }} /> */}
                                  <i className="flaticon-users-1 display-4 text-muted font-weight-bold"></i>
                                  <div className="col">
                                    <div className="fs-4 fw-bolder">
                                      {coinStoresForEdit?.data[0]?.param
                                        ?.activeAds || 0}
                                    </div>
                                    <div
                                      className="font-weight-bold fs-6 text-gray-400"
                                      style={{
                                        color: "var(--color_border_color)",
                                      }}
                                    >
                                      Active Ads
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Accordion.Collapse>
            </div>
          </Accordion>
        </div>
      </Col>
    );
  };

  const createFormInputs = () => {
    return (
      <div
        className="report-filter-bLock border-0 row align-items-center"
        style={{ padding: "0px 0", margin: "0px" }}
      >
        <Formik
          initialValues={{ dateRang: dateRange }}
          onSubmit={(values) => {
            console.log("val::22", values);
            applyFilter(values);
          }}
        >
          {({ handleSubmit }) => (
            <div className="col-lg-12 col-md-12">
              <form
                onSubmit={handleSubmit}
                className="form form-filter w-100"
                autoComplete="off"
              >
                <div className="form-group row m-0 align-items-center">
                  <div className="col-md-6 col-lg-3 mb-3">
                    <label>Date Range</label>
                    <DateRangPickerField
                      name="dateRang"
                      placeholder="Select Date Range"
                    />
                  </div>
                  <div className="col-md-6 col-lg-3 mb-3">
                    <label>Select Country</label>
                    <DropdownReactSelect
                      placeholder="Select Country"
                      name="companies"
                      value={countrySelectedDropdownFilterData}
                      isMulti={true}
                      isClearable={true}
                      isSearchable={true}
                      closeMenuOnSelect={true}
                      options={[
                        { value: "all", label: "All Countries" },
                        ...countryDropdownFilterData,
                      ]}
                      onChange={setCountryListDropdownFilterData}
                    />
                  </div>
                  <div className="col-xxl-1 col-md-6 col-lg-2 mb-3 d-flex justify-content-md-end">
                    <button
                      type="submit"
                      className="btn btn-dark"
                      style={{ width: "100%", marginTop: "20px" }}
                    >
                      Search
                    </button>
                  </div>
                  <div className="col-xxl-1 col-md-6 col-lg-2 mb-3 d-flex justify-content-md-end custom-marginn-xxl ">
                    {helperFunc.isButtonAccess("downloadAds.adsCompanyList.add") && (
                      <button
                        type="button"
                        className="btn btn-dark custom-marginn-md"
                        style={{ width: "100%", marginTop: "20px" }}
                        onClick={newItem}
                      >
                        Add Ads
                      </button>
                    )}
                  </div>
                </div>
              </form>
            </div>
          )}
        </Formik>
        <div className="col-lg-1 col-md-1 mt-4 d-flex justify-content-end">
          <div className="d-flex px-4"></div>
        </div>
      </div>
    );
  };

  return (
    <>
      <Card>{createBasicDetails()}</Card>
      <Card className="">
        <NotificationContainer />
        <div className="card-header p-0">
          <div className="my-5 w-100 row mx-auto">{createFormInputs()}</div>
        </div>

        <CardBody className="p-0">
          {searchApply === true ? (
            listLoading === false && totalCount === 0 ? (
              UIHelpers.dataTableNoData()
            ) : (
              <DataTable
                rows={rows ? rows : []}
                columns={allColumns}
                paginantionTotalAmountOfData={totalCount}
                DataTablePaginationAPICall={DataTablePaginationAPICall}
              />
            )
          ) : (
            ""
          )}
        </CardBody>
      </Card>
    </>
  );
}
